import { get, post } from './httpClient'

//params: action, type, search, date
export const getLogs = (params) => get('/history', { ...params })
export const addTrackingLog = (body) => post('/trackinglog/create', body)
export const getTrackingLogs = (params) => get('/trackinglog', params)
export const getTrackingMore = (params) => get('/trackingmore/all', params)
